import React, { useEffect, useState } from "react";
import { BackArrowIcon, WeddingUnderline } from "../../utils/SvgComponents";
import { useNavigate } from "react-router-dom";
import CustomButton from "./button/Button";

const PageHeading = ({
	title,
	color = false,
	mainStyle = {},
	backIcon = {},
	showUnderline = true,
	backTo = null,
}) => {
	// const [isActive, setIsActive] = useState(false);

	// useEffect(() => {
	// 	const handleScroll = () => {
	// 		const scroll = window.scrollY;
	// 		if (scroll > 0) {
	// 			setIsActive(true);
	// 		} else {
	// 			setIsActive(false);
	// 		}
	// 	};

	// 	window.addEventListener("scroll", handleScroll);

	// 	// Cleanup function to remove the event listener
	// 	return () => {
	// 		window.removeEventListener("scroll", handleScroll);
	// 	};
	// }, []);
	const navigate = useNavigate();
	const handleBack = () => {
		if (window.location.pathname.includes("GalleryImage")) {
			if (window.history.length > 1) {
				navigate(-1);
			} else {
				window.close();
			}
		} else {
			navigate(-1);
		}
	};
	return (
		// <div id="header" className={`${isActive ? "active" : ""}`}>
		<div
			className="flex gap-3 justify-center items-center"
			style={{ ...mainStyle }}
		>
			<div className="" onClick={() => handleBack()}>
				<div
					className={`bg-${!color ? "white" : "black"
						} rounded-full p-1 whiteripple`}
					style={{ ...backIcon }}
				>
					<CustomButton clicked={() => { }}>
						<BackArrowIcon
							fill={`${!color ? "black" : "white"}`}
							width="35"
							height="35"
						/>
					</CustomButton>
				</div>
			</div>
			<div className="flex flex-col justify-center items-center">
				<div
					className="text-[25px] md:text-[40px] sm:text-[30px] mb-[12px] style-script-regular"
					style={{
						fontFamily: "Baby Giovani Script",
						color: `${color ? "white" : "black"}`,
					}}
				>
					{title}
				</div>
				<div>
					{showUnderline && (
						<WeddingUnderline
							color={`${color ? "white" : "black"}`}
							lineWidth={"280"}
						/>
					)}
					{/* </div> */}
				</div>
			</div>
		</div>
	);
};

export default PageHeading;
